import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filtro'
})
export class FiltroPipe implements PipeTransform {

  transform(value: any, page:number = 0, search: string = '', field: string = 'name'): any[] {
    if ( search.length === 0) {
      return value.slice(page, page + 100)
    }
    //let filter = value.filter((item: any) => item.nombreCompleto.includes(search));
    let filter = value.filter((item: any) =>
      item.nombreCompleto.toLowerCase().includes(search.toLowerCase())
    );
   return filter.slice(page, page + 100);
  }

}



// WEBPACK FOOTER //
// ./src/pipes/filtro.pipe.ts